import DallE3 from './DallE3'

export default DallE3
